import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import VIPContactViewModel from "@/models/VIPContactViewModel";
import { ref } from "vue";
export default function () {
    const VIPcontacts = ref<Array<VIPContactViewModel>>([]);
    const getVIPContacts = async () => {
        await defineHeaderAxios();
        Axios.get("/api/vipcontact")
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    VIPcontacts.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    getVIPContacts();
    return {
        VIPcontacts,
        getVIPContacts,
    };
}
